module.exports = __webpack_public_path__ + "static/media/spliceTwo.f0f13c93.png";